const roles = [
  { code: 'LB_Terminal', text: 'Liquid Bulk - Terminal' },
  { code: 'LB_Agent', text: 'Liquid Bulk - Agent' },
  { code: 'LB_Surveyor', text: 'Liquid Bulk - Surveyor' },
  { code: 'LB_Ship', text: 'Liquid Bulk - Ship' },
  { code: 'LB_Cargo', text: 'Liquid Bulk - Cargo' },
  { code: 'LB_Admin', text: 'Liquid Bulk - Admin' },
];

const getRoleText = (selectedRoles) => {
  const selectedValues = [];

  selectedRoles.forEach((selectedRole) => {
    const value = roles.find(r => r.code === selectedRole).text;
    selectedValues.push(value);
  });

  return selectedValues.join(', ');
};

export {
  roles,
  getRoleText,
};
